import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue';
import IconMinus from '@white-label-icon/icon-minus';
import IconPlus from '@white-label-icon/icon-plus';
import TextField from '../text-field/text-field.vue';

interface NumSelectorProps {
  minusDisabled?: boolean;
  plusDisabled?: boolean;
  modelValue?: number;
  location?: string;
  customerGroup?: string;
  type?: string;
  prefix?: string;
  customError?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'num-selector',
  props: {
    minusDisabled: { type: Boolean, default: false },
    plusDisabled: { type: Boolean, default: false },
    modelValue: { default: 0 },
    location: { default: '' },
    customerGroup: { default: 'default' },
    type: { default: 'default' },
    prefix: { default: '' },
    customError: { default: '' }
  },
  emits: ["update:modelValue", "error", "enter"],
  setup(__props: any, { expose, emit }: { emit: ({
  (event: 'update:modelValue', value: number): void
  (event: 'error', payload: { num: number; isDisabled: boolean }): void
  (event: 'enter'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { minusDisabled: boolean, plusDisabled: boolean, modelValue: number, location: string, customerGroup: string, type: string, prefix: string, customError: string };





const internalValue = ref(Number(props.modelValue));

watch(
  () => props.modelValue,
  (newValue) => {
    internalValue.value = Number(newValue);
  }
);

const items = computed(() => {
  return Array(Math.max(internalValue.value + 3, 10))
    .fill(0)
    .map((_, num) => num);
});

const onFormFieldInput = (val: number | string) => {
  internalValue.value = Number(val);
  emit('update:modelValue', Number(val))
}

const add = (num: number, isDisabled: boolean) => {
  if (isDisabled) {
    emit('error', { num, isDisabled });
  } else {
    const newValue = internalValue.value + num;
    internalValue.value = newValue;
    emit('update:modelValue', newValue);
  }
};

const keydownUpHandler = (event: KeyboardEvent) => {
  const numSelectors = document.querySelectorAll<HTMLDivElement>('.num-selector');
  numSelectors.forEach((numSelector, index) => {
    if (event.target === numSelector && index !== numSelectors.length && index !== 0) {
      numSelectors[index - 1].focus();
      event.preventDefault();
    }
  });
};

const keydownDownHandler = (event: KeyboardEvent) => {
  const numSelectors = document.querySelectorAll<HTMLDivElement>('.num-selector');
  numSelectors.forEach((numSelector, index) => {
    if (event.target === numSelector && index !== numSelectors.length && index !== numSelectors.length - 1) {
      numSelectors[index + 1].focus();
      event.preventDefault();
    }
  });
};

expose({
  onFormFieldInput,
  add
});

return { __sfc: true,props, emit, internalValue, items, onFormFieldInput, add, keydownUpHandler, keydownDownHandler, IconMinus, IconPlus, TextField }
}

})